module.exports = __webpack_public_path__ + "media/images/payment_cards/payment-card-bg-ad6baa8c80fcafe587111cc7d11a4728.svg";